import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=44d9cbcd&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=44d9cbcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d9cbcd",
  null
  
)

export default component.exports